import React from 'react';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, SearchResultCollectorFragmentDoc } from '@graphql/reactQuery';
import { useGetDominantBackgroundColor } from '@hooks/useGetDominantBackgroundColor';
import { UserCard } from './UserCard';

export const CollectorUserCard = ({
  collector,
}: {
  collector: FragmentType<SearchResultCollectorFragmentDoc>;
}) => {
  const collectorFrag = getFragment(SearchResultCollectorFragmentDoc, collector);

  const dominantColor = collectorFrag?.avatar?.dominantColor;

  const userCardDominantColor = useGetDominantBackgroundColor({ dominantColor });

  if (!collectorFrag) return null;

  return (
    <UserCard
      name={collectorFrag.username}
      coverImageSrc={collectorFrag.avatar?.url}
      webappUri={collectorFrag.webappUri}
      label="Collector"
      showVerified={false}
      metadata={undefined}
      showSBackground={false}
      publicAddress={collectorFrag.publicAddress}
      dominantColor={userCardDominantColor}
    />
  );
};
